import { getTypeOrNull } from '@spotify/confidence-graphql';
import { useCurrentUser } from '@spotify/plugin-confidence-iam-react';

import { usePresenceHeartbeat } from '../../hooks/usePresenceHeartbeat';

// Headless: broadcasts the signed-in user's presence while mounted. Mount once
// inside the authenticated app shell so the user is reported as online (e.g. in
// the mobile "Teammates online" view). Reading the presence list is handled
// separately by usePresences/usePresence.
export const PresenceTracker = (): null => {
  const { currentUser } = useCurrentUser();
  const currentIdentityName =
    getTypeOrNull(currentUser?.identity)?.name ?? null;

  usePresenceHeartbeat({ enabled: Boolean(currentIdentityName) });

  return null;
};
